export default "__VITE_ASSET__e838ae1a__"